import { ApiConfig } from '~shared/constants';
import { Component, Input, OnInit, OnChanges, Inject, PLATFORM_ID } from '@angular/core';
import { MarketDetectionUtil } from '~shared/utils/market-detection.util';
import { getOtherBucketsUrl } from '~shared/modules/catalog/utils/other-buckets.utils';
import { OTHER_BUCKETS_TITLE, OtherBuckets } from '~shared/modules/catalog/constants/other-buckets.constants';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { SearchBannerApplicationEvent } from '~shared/modules/application-event/models';
import {
  ZRPOtherBucketClickedApplicationEventModel
} from '~shared/modules/application-event/models/ZRP-other-bucket-clicked-application-event.model';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-other-buckets-banner',
  templateUrl: './other-buckets-banner.component.html',
  styleUrls: ['./other-buckets-banner.component.scss'],
})
export class OtherBucketsBannerComponent implements OnInit, OnChanges {
  imageUrl = `${ApiConfig.CDN_IMAGE_URL()}/search-no-result/no-result@1x.png`;
  eOtherBuckets = OtherBuckets;
  bucketTitles = OTHER_BUCKETS_TITLE;
  showBucketsBanner = false;

  @Input() searchQuery: string;
  @Input() isZeroResult: boolean;

  private OTHER_BUCKETS_URL: { offerAndStore: string, deliveryService: string }

  constructor(
    private applicationEventService: ApplicationEventService,
    private translateService: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.showBucketsBanner = this.searchQuery !== undefined;
    this.initializeOtherBucketUrls()
  }

  ngOnChanges(): void {
    this.showBucketsBanner = this.searchQuery !== undefined;
  }

  initializeOtherBucketUrls(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.OTHER_BUCKETS_URL = getOtherBucketsUrl(MarketDetectionUtil.getCountryCode())
    }
  }

  redirectToOtherBucket(bucket: OtherBuckets): void {
    // GA tracking for search exit banners
    this.applicationEventService.publish(new SearchBannerApplicationEvent(this.searchQuery));
    if (this.isZeroResult) {
      const otherBucketLink = `${this.translateService.instant('CATALOG.CATALOG_PAGE.OTHER_BUCKETS_BANNER.SEARCH')} '${
        this.searchQuery
      }' ${this.translateService.instant(
        'CATALOG.CATALOG_PAGE.OTHER_BUCKETS_BANNER.IN'
      )} ${this.translateService.instant(this.bucketTitles[bucket])}`;
      this.applicationEventService.publish(
        new ZRPOtherBucketClickedApplicationEventModel(GATrackingEventType.ZRPOtherBuckets, otherBucketLink)
      );
    }

    if (this.OTHER_BUCKETS_URL?.[bucket]) {
      window.open(`${this.OTHER_BUCKETS_URL[bucket]}${this.searchQuery}`, '_blank');
    }
  }
}
